import { compose } from 'recompose';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';
import { CampaignCarousel } from './CampaignCarousel';

const enhance = compose(withDeviceInfo);

export default enhance(CampaignCarousel);
